import styled, { css } from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
  position: absolute;
  bottom: -1px;
  left: 0;
  background: #fff;
  box-shadow: 0px -22px 15px -5px #fff;
  padding-bottom: 10px;
  border-radius: 0 0 16px 16px;

  @media (min-width: 1024px) {
    bottom: 0;
  }
`;

export const Button = styled.button`
  border-radius: 8px;
  background: #fff;
  display: inline-grid;
  align-items: center;
  cursor: pointer;
  justify-content: center;
  padding: 10px 12px;
  position: relative;
  width: 172px;
  font-size: 16px;
  line-height: 20px;
  ${({ theme }) => css`
    color: ${theme.primaryColor};
    border: 2px solid ${theme.primaryColor};
    text-transform: ${theme.btnTextTransform};
    font-weight: ${theme.btnTextWeigth};
  `};
`;
